export default __webpack_public_path__ + "static/media/Meeting-EN.3d4fdaf1.png";